import Formation from "@/models/Formation";

const getDefaultState = () => ({
    requiredPOACount: 0,
});

export default {
    namespaced: true,
    
    state: getDefaultState(),

    getters: {
        requiredPOACount(state) {
            return state.requiredPOACount;
        },
    },

    mutations: {
        RESET_POA_COUNT(state) {
            state.requiredPOACount = 0;
        },
        
        SET_REQUIRED_POA_COUNT(state, data) {
            state.requiredPOACount = data.count;
        },

        UPDATE_POA_REQUIRE_COUNT(state, count) {
            state.requiredPOACount = count;
        }
    },

    actions: {
        async REQUIRE_POA({ commit }) {
            commit('SET_REQUIRED_POA_COUNT', await Formation.requiredPOACount());
        },
    }
};
